<script setup></script>
<template>
	<section class="stages" id="stages">
		<div class="container">
			<h2 class="stages__title title2 --red">Этапы конкурса</h2>
			<h3 class="stages__subtitle">После одобрения заявки:</h3>
			<ul class="stages__list">
				<li class="stages__item">
					<div class="stages__number">1</div>
					<div class="stages__content">
						<h3 class="stages__date">
							С 1 сентября <br />
							по 20 сентября 2025
						</h3>
						<p class="stages__text">Регистрация заявок <br class="--x480"> на участие в конкурсе</p>
					</div>
				</li>
				<li class="stages__item">
					<div class="stages__number">2</div>
					<div class="stages__content">
						<h3 class="stages__date">
							 по 
							20 сентября 2025
						</h3>
						<p class="stages__text">
							Отбор заявок <br />
							на участие в конкурсе
						</p>
					</div>
				</li>
				<li class="stages__item">
					<div class="stages__number">3</div>
					<div class="stages__content">
						<h3 class="stages__date">
							с 20 сентября <br/> по 30 
							сентября 2025
						</h3>
						<p class="stages__text">Время на подготовку запуска авторского меню</p>
					</div>
				</li>
				<li class="stages__item">
					<div class="stages__number">4</div>
					<div class="stages__content">
						<h3 class="stages__date">
							с 1 ОКТЯБРЯ <br/> ПО 20 
							ОКТЯБРЯ 2025
						</h3>
						<p class="stages__text">Размещение авторского меню в заведении</p>
					</div>
				</li>
				<li class="stages__item">
					<div class="stages__number">5</div>
					<div class="stages__content">
						<h3 class="stages__date">
							С 21 ОКТЯБРЯ <br/> ПО 31 
							ОКТЯБРЯ 2025
						</h3>
						<p class="stages__text">Оценка работ и выбор трех финалистов</p>
					</div>
				</li>
				<li class="stages__item">
					<div class="stages__number">6</div>
					<div class="stages__content">
						<h3 class="stages__date">11 ноября 2025</h3>
						<p class="stages__text">Финал в Москве</p>
						<span class="stages__desc">
							Организаторы приглашают трех финалистов в Москву в ресторан Savva, где они презентуют два блюда из авторского меню членам жюри. 
							Затраты на посещение финала компенсируют Организаторы
						</span>
					</div>
				</li>
			</ul>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
br {
	&.--x480 {
		display: none;
		@media (max-width: vars.$x480) {
			display: block;
		}
	}
}
.stages {
	padding: 6rem 0 11.3rem;
	background: linear-gradient(180deg, #fff 0%, #fff9eb 100%);
	@media (max-width: vars.$x480) {
		padding: 5.2rem 0 6.2rem;
	}
}

.stages__title {
	text-align: center;
	margin-bottom: 7rem;

	@media (max-width: vars.$x480) {
		margin-bottom: 32px;
        text-align: start;
	}
}
.stages__subtitle {
	font-family: var(--font-family-md);
	font-weight: 500;
	font-size: 1.6rem;
	line-height: 130%;
	text-transform: uppercase;
	color: var(--red);
	margin-bottom: 26px;
	padding-bottom: 8px;
	border-bottom: 1px solid var(--red);
	display: none;
	@media (max-width: vars.$x480) {
		display: inline-block;
	}
}
.stages__list {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	align-items: start;
	gap: 0px 4.6rem;
	@media (max-width: vars.$t) {
		grid-template-columns: repeat(2, 1fr);
	}
    @media (max-width: vars.$xx) {
        grid-template-columns: 1fr;
    }
}
.stages__item {
	position: relative;
	display: flex;
	align-items: center;
	gap: 2.7rem;
	@media (max-width: vars.$x480) {
		gap: 1.5rem;
	}
	&:nth-child(1) {
		padding-bottom: 5.5rem;
        @media (max-width: vars.$x480) {
            padding-bottom: 3.5rem;
        }
	}
	&:nth-child(2) {
		padding-bottom: 5.5rem;
		@media (max-width: vars.$t) {
			.stages__content {
				&::before {
					display: none;
				}
			}
		}
        @media (max-width: vars.$x480) {
            padding-bottom: 3.5rem;
        }
	}
	&:nth-child(3) {
		padding-bottom: 5.5rem;
        @media (max-width: vars.$x480) {
            padding-bottom: 3.5rem;
        }
		.stages__content {
			&::before {
				display: none;
				@media (max-width: vars.$t) {
					display: block;
				}
				@media (max-width: vars.$xx) {
					display: none;
				}
			}
		}
	}
	&:nth-child(4) {
		padding-top: 5.5rem;
		padding-bottom: 4.5rem;
		@media (max-width: vars.$t) {
			padding-top: 0rem;
			.stages__content {
				&::before {
					display: none;
				}
			}
		}
        @media (max-width: vars.$x480) {
            padding-bottom: 3.5rem;
        }
        &::before {
            @media (max-width: vars.$t) {
                
                height: 107%;
            }
            @media (max-width: vars.$xx) {
                height: 100%;
            }
        }
	}
	&:nth-child(5) {
		padding-top: 5.5rem;
		padding-bottom: 4.5rem;
		@media (max-width: vars.$t) {
			padding-top: 0rem;
		}
        @media (max-width: vars.$x480) {
            padding-bottom: 3.5rem;
        }
	}
	&:nth-child(6) {
		padding-top: 5.5rem;
		@media (max-width: vars.$t) {
			padding-top: 0rem;
		}
		.stages__content {
			&::before {
				display: none;
			}
		}
		.stages__number {
			margin-bottom: 4.5rem;
			@media (max-width: vars.$t) {
				margin-bottom: 3.5rem;
			}
		}
		.stages__text {
			color: var(--red);
			font-size: 1.8rem;
		}
	}
	&::before {
		position: absolute;
		content: "";
		top: -1rem;
		left: 4rem;
		width: 1px;
		height: 100%;
		background: var(--black);
		opacity: 0.3;
        @media (max-width: vars.$x480) {
            left: 2.1rem;

        }
	}
}
.stages__number {
	font-weight: 400;
	font-size: 5.4rem;
	line-height: 111%;
	color: var(--red);

	@media (max-width: vars.$x480) {
		font-size: 3rem;
	}
}
.stages__content {
	width: 100%;
	position: relative;
	display: grid;
	gap: 1rem;
    @media (max-width: vars.$x480) {
        gap: .7rem;
    }
	&::before {
		position: absolute;
		content: "";
		background-image: url("@/assets/img/icons/stages_item_decor.svg");
		background-repeat: no-repeat;
		background-position: 0px 0px; /* x y*/
		background-size: auto; /* w h*/
		width: 10.5rem;
		height: 0.4rem;
		top: 6%;
		right: -7rem;
		@media (max-width: vars.$t) {
			right: -2rem;
		}
		@media (max-width: vars.$xx) {
			display: none;
		}
	}
}
.stages__date {
	font-weight: 700;
	font-size: 2rem;
	line-height: 120%;
	text-transform: uppercase;
	color: var(--red);
	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
	}
}
.stages__text {
	font-family: var(--font-family-md);
	font-weight: 500;
	font-size: 1.8rem;
	line-height: 125%;
	text-transform: uppercase;
	color: var(--black);
	@media (max-width: vars.$x480) {
		font-size: 1.4rem;
	}
}
.stages__desc {
	font-weight: 400;
	font-size: 1.4rem;
	line-height: 120%;
	color: #000;
	padding-right: 2.5rem;
	@media (max-width: vars.$x425) {
		max-width: 32.5rem;
		padding-right: 1rem;
	}
}
</style>
